/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useRedirectAfterVehicleChanged } from '@/features/category/hooks/useRedirectAfterVehicleChanged';
import { useQueryClient } from '@tanstack/react-query';
import { dealListQuery } from '@/features/deals/api/getDealList';
import { YMMEModal } from '@/features/ymme/components/YMMEModal';

type Props = {
  setShowYmme?: (showYmme: boolean) => void;
  onClose: (vehicleWasSelected?: boolean) => void;
  showYmme: boolean;
};

export const BundleDealVehicleSelection = ({ onClose, setShowYmme, showYmme }: Props) => {
  const redirectAfterVehicleChanged = useRedirectAfterVehicleChanged();
  const queryClient = useQueryClient();

  const invalidateDealsQuery = () => {
    void queryClient.removeQueries({ queryKey: [dealListQuery.getPrimaryKey()] });
  };

  const handleVehicleUpdate = () => {
    invalidateDealsQuery();
    void redirectAfterVehicleChanged();
    setShowYmme?.(false);
    onClose(true);
  };

  return (
    <YMMEModal
      pageType="bundleDealsDrawer"
      showYmme={showYmme}
      closeYmmeWidget={onClose}
      onUpdateVehicleSuccess={handleVehicleUpdate}
    />
  );
};
